import { useCommonMutation } from 'hooks';
import { loginKeys } from '../keys/login.key';
import {
  LoginAPI,
  ReqChangePassword,
  ReqChangePasswordForce,
  ReqLogin,
  ResLogin
} from 'domains/Auth';
import { BaseApiResponse, ResultError } from 'modules';
import { ReqForgotPassword } from '../models/forgot-password.model';

const authApi = new LoginAPI();

export const useLogin = () => {
  return useCommonMutation<BaseApiResponse<ResLogin>, ResultError, ReqLogin>({
    mutationKey: loginKeys.POST_LOG_IN(),
    mutationFn: (data) => authApi.login(data)
  });
};

export const useChangePassword = () => {
  return useCommonMutation<BaseApiResponse, ResultError, ReqChangePassword>({
    mutationKey: loginKeys.CHANGE_PASSWORD(),
    mutationFn: (data) => authApi.changePassword(data)
  });
};

export const useForgotPassword = () => {
  return useCommonMutation<BaseApiResponse, ResultError, ReqForgotPassword>({
    mutationKey: loginKeys.FORGOT_PASSWORD(),
    mutationFn: (data) => authApi.forgotPassword(data)
  });
};

export const useChangePasswordForce = () => {
  return useCommonMutation<BaseApiResponse, ResultError, ReqChangePasswordForce>({
    mutationKey: loginKeys.CHANGE_PASSWORD_FORCE(),
    mutationFn: (data) => authApi.changePasswordForce(data)
  });
};
